import { type FC, type ReactNode, createContext, useContext } from "react";

import { initialEaselState } from "~/components/canvas/easel/EaselContext";
import { type QueryBuilderStateManager } from "~/components/canvas/easel/query-builder/QueryBuilderStateManager";

const QueryBuilderStateContext = createContext<QueryBuilderStateManager>(
	initialEaselState.queryBuilderStateManager
);

export type QueryBuilderStateProviderProps = {
	queryBuilderStateManager: QueryBuilderStateManager;
	children?: ReactNode;
};

export const QueryBuilderStateProvider: FC<QueryBuilderStateProviderProps> = ({
	queryBuilderStateManager,
	children,
}) => {
	return (
		<QueryBuilderStateContext.Provider value={queryBuilderStateManager}>
			{children}
		</QueryBuilderStateContext.Provider>
	);
};

export const useQueryBuilderStateManager = () => {
	const queryBuilderStateManager = useContext(QueryBuilderStateContext);
	const { useQueryBuilderState } = queryBuilderStateManager;
	const queryBuilderState = useQueryBuilderState();
	return { queryBuilderState, queryBuilderStateManager };
};
